import { type IHydratedWidget } from '../../../../../hydrate/IHydrationContext.ts';
import { wrapWithMarginStyleDiv } from '../../../../directives/margin/generateMarginStyle.ts';
import { type IHtmlRenderContext } from '../../../IWidgetType.ts';
import { type IDividerWidget } from './IDividerWidget.ts';

export function renderDividerHtml(
  widget: IHydratedWidget<IDividerWidget>,
  _context: IHtmlRenderContext,
): string {
  const titleHtml = widget.title
    ?.filter(item => item.text)
    .map(item => item.text)
    .join('');
  let dividerHtml = `<hr style="border:none;border-top:1px solid #d9d9d9;margin:8px 0;"/>`;

  if (titleHtml) {
    dividerHtml = `<div style="border-bottom:1px solid #d9d9d9;padding-bottom:4px;margin-bottom:8px;font-weight:bold">${titleHtml}</div>`;
    return wrapWithMarginStyleDiv(dividerHtml, widget.directives?.margin);
  }

  return wrapWithMarginStyleDiv(dividerHtml, widget.directives?.margin);
}
